import {Organization, OrganizationField} from "../../app/api/model/organization";
import MultiFieldAsyncSelector, {MultiFieldAsyncSelectorProps} from "./MultiFieldAsyncSelector";
import {useOrganizationListQuery} from "../../app/api/api";

type OrganizationSelectorProps = Omit<MultiFieldAsyncSelectorProps<Organization>, "query" | "fields">;

export default function OrganizationSelector(props: OrganizationSelectorProps) {
    return (
        <MultiFieldAsyncSelector
            {...props}
            query={useOrganizationListQuery}
            fields={[
                {fieldName: OrganizationField.NAME, labelKey: "organizations_name"},
                {
                    fieldName: OrganizationField.MAIN_DKV_CUSTOMER_NUMBER,
                    labelKey: "organizations_mainDKVCustomerNumber",
                },
                {fieldName: OrganizationField.COUNTRY, labelKey: "generic_country", isReadOnly: true},
                {fieldName: OrganizationField.ALL_STAGES, labelKey: "organizations_allStages", isReadOnly: true},
                {fieldName: OrganizationField.LOCKED, labelKey: "organizations_globalLocked", isReadOnly: true},
                {fieldName: OrganizationField.LOCKED_REASON, labelKey: "organizations_lockedReason", isReadOnly: true},
            ]}
        />
    );
}
